import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    CircularProgress,
    Typography,
    Box
} from '@mui/material';
import { Enrollment } from '../../types/enrollment';
import api from '../../services/api';

interface EnrollmentPostponeModalProps {
    open: boolean;
    onClose: () => void;
    enrollment: Enrollment | null;
    onUpdated: () => void;
}

const EnrollmentPostponeModal: React.FC<EnrollmentPostponeModalProps> = ({ open, onClose, enrollment, onUpdated }) => {
    const [loading, setLoading] = useState(false);
    const [newEndDate, setNewEndDate] = useState('');
    const [reason, setReason] = useState('');

    const handleSubmit = async () => {
        if (!enrollment || !newEndDate || !reason) return;
        setLoading(true);
        try {
            await api.post(`/api/enrollment/${enrollment._id}/postpone`, {
                newEndDate,
                reason
            });
            onUpdated();
            onClose();
        } catch (err) {
            console.error('Error postponing enrollment', err);
        } finally {
            setLoading(false);
        }
    };

    if (!enrollment) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    overflow: 'hidden',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                }
            }}
        >
            <DialogTitle>Reporter l'inscription</DialogTitle>
            <DialogContent dividers>
                <Box mb={2}>
                    <Typography variant="body2" color="text.secondary">
                        Date de fin actuelle : {new Date(enrollment.endDate).toLocaleDateString('fr-FR')}
                    </Typography>
                </Box>
                <TextField
                    label="Nouvelle date de fin"
                    type="date"
                    value={newEndDate}
                    onChange={(e) => setNewEndDate(e.target.value)}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    required
                />
                <TextField
                    label="Motif du report"
                    multiline
                    rows={3}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Annuler</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="warning"
                    disabled={loading || !newEndDate || !reason}
                >
                    {loading ? <CircularProgress size={24} /> : 'Reporter'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default EnrollmentPostponeModal;
